// Keep Fit App - TypeScript 類型定義

// 營養數據
export interface Nutrition {
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
  sugar: number;
  sodium: number;
}

// 食物分析結果
export interface FoodAnalysis {
  foodName: string;
  confidence: number;
  nutrition: Nutrition;
  ingredients: string[];
  healthTips: string;
  estimatedPortion?: string;
  usedModel?: string;  // 實際使用的模型
}

// 飲食記錄
export interface FoodRecord {
  id: string;
  userId: string;
  mealType: 'breakfast' | 'lunch' | 'dinner' | 'snack';
  foodName: string;
  foodImageUrl?: string;
  aiConfidence?: number;
  calories: number;
  protein: number;
  fat: number;
  carbs: number;
  sugar: number;
  sodium: number;
  ingredients?: string[];
  healthTips?: string;
  notes?: string;
  recordDate: string;
  createdAt: string;
}

// 用戶設定
export interface UserSettings {
  id: string;
  displayName?: string;
  avatarUrl?: string;
  targetCalories: number;
  targetProtein: number;
  targetFat: number;
  targetCarbs: number;
}

// 每日統計
export interface DailySummary {
  date: string;
  totalCalories: number;
  totalProtein: number;
  totalFat: number;
  totalCarbs: number;
  totalSugar: number;
  totalSodium: number;
  recordCount: number;
}

// API 回應
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: {
    code: string;
    message: string;
  };
}

// 分析請求
export interface AnalyzeRequest {
  image: string;  // base64
  mimeType: string;
  model?: string;  // 可選：指定模型
}

// 分析回應
export interface AnalyzeResponse {
  analysis: FoodAnalysis;
  cached: boolean;
  provider: string;
}

// 餐類型標籤
export const MEAL_TYPE_LABELS: Record<string, string> = {
  breakfast: '早餐',
  lunch: '午餐',
  dinner: '晚餐',
  snack: '小食',
};

// 營養目標預設值
export const DEFAULT_TARGETS: Nutrition = {
  calories: 2000,
  protein: 50,
  fat: 65,
  carbs: 300,
  sugar: 50,
  sodium: 2300,
};
